import * as React from 'react';
import { useSelector } from 'react-redux';
import { useQrsHandler } from '../../wave/hooks/useQrsHandler';
import { layeredQrsWavesSelector } from '../../wave/selectors/wave.selectors';
import { Waves } from './Waves';

export const QrsWaves: React.FC = () => {
  const handler = useQrsHandler();
  const [backgroundWaveIds, foregroundWaveIds] = useSelector(
    layeredQrsWavesSelector,
  );

  return (
    <Waves
      handler={handler}
      background={backgroundWaveIds}
      foreground={foregroundWaveIds}
    />
  );
};
